<template>
    <div class="">
        <MainPage customClass="show-bottom-shoping-cart lg:max-w-2xl" @clickBack="clickBack()" >
            <div class="" v-if="isLogin && PlaceOrderStore.state.placeOrder">
                <div class="px-4">
                    <CartStatus :isPayment="isPayment"></CartStatus>
                </div>
                <InfoProfileForm
                    ref="payment-form"
                    v-model:formValid="formValid"
                ></InfoProfileForm>
                <div class="px-4">
                    <PaymentMethod
                        ref="payment-method"
                        :disablePayment = "disablePayment"
                    ></PaymentMethod>
                </div>
                <div class="px-4">
                    <TaxInvoice 
                        ref="tax-invoice"
                        :disableTaxInvoice = "disableTaxInvoice"
                    ></TaxInvoice>
                </div>
                <div class="absolute lg:relative bottom-0 left-0 w-full bg-a-egg-f5ebdc border-t border-a lg:border-0 shadow-top lg:shadow-none px-4 py-3 lg:py-6" >
                    <div class="text-center text-a-brown-502314 font-bold lg:text-18">{{getTotal()}}</div>
                    <div class="flex py-3">
                        <img class=" mr-0 ml-auto my-auto" src="@/assets/icon/ic-reward-green.svg" />
                        <div class="text-a-green-198737 ml-1 mr-auto my-auto text-14 lg:text-16">{{getPoint()}}</div>
                    </div>
                    <div class="lg:px-20">
                        <div class="text-a-egg-f5ebdc font-bold bg-a-red-d62300 text-center w-full rounded-full py-2.5 lg:text-18 cursor-pointer"
                            @click="clickPlaceOrder()">
                            {{lbl.shoppingcart.placeorder}}
                        </div>
                    </div>
                    
                </div>
            </div>
        </MainPage>
        <a class="hidden" id="omiselink" href="https://omise.com">omise</a>
        <a class="hidden" id="applink" href="https://google.com">applink</a>
    </div>
</template>

<script>
//config
import ConfigManager from '@/config/ConfigManager.js';
//helper
import Util from '@/helper/Utility.js';
import CacheHelper from "@/helper/CacheHelper";
//components
import MainPage from "@/components/Layout/Page/MainPage.vue";
import CartStatus from "../component/CartStatus.vue";
import InfoProfileForm from "../component/Form/InfoProfileForm.vue";
import PaymentMethod from "../component/PaymentMethod.vue";
import TaxInvoice from "../component/TaxInvoice.vue";
//service
import BKCart from '../service/BKCart.js';
//model
import { PaymentModel } from '../model/PaymentModel.js';
//Mixin
import AuthStatusMixin from '@/mixin/AuthStatusMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
import DeliveryMixin from '@/mixin/DeliveryMixin.js'
import ErrorApiMixin from '@/mixin/ErrorApiMixin';
import { window } from 'rxjs/operators';
export default {
    name: "OrderPayment",
    inject: ['PlaceOrderStore','ShippingStore','CartCountStore'],
    mixins: [AuthStatusMixin,ModalMixin,LocaleMixin,DeliveryMixin,ErrorApiMixin],
    components: {
        MainPage,
        CartStatus,
        InfoProfileForm,
        PaymentMethod,
        TaxInvoice
    },
    data: function() {
        return {
            isAllowClick: true,
            isPayment: true,
            KEY_COOKIE_RETURN_URL: 'return_url',
            
            formValid: false,
            loadingStatus: {
                placeOrder: false,
            },
            isMatchDriver: false,
            isShowTryAgain: false,


            paymentModel: new PaymentModel(),
            interval: null,
            intervalQr: null,
            omiseUrl: null,
            qrPaymentUrl: null,
            qrExpireInSeconds: 0,
            timeOutTryAgain: null,
            disablePayment: false,
            disableTaxInvoice: false,
        }
    },
    created: function() {
        this.PlaceOrderStore.methods.init();
        this.ShippingStore.methods.init();
        this.isAllowClick = true;
        this.disablePayment = this.PlaceOrderStore.state.placeOrder.total == 0 ? true : false;
        this.disableTaxInvoice = this.PlaceOrderStore.state.placeOrder.total == 0 ? true : false;

    },
    unmounted: function() {
        clearInterval(this.interval);
        clearInterval(this.intervalQr);
        clearTimeout(this.timeOutTryAgain);
        this.modal.loadingModal.hide();
        this.modal.loadingDeliveryModal.hide();
        this.modal.qrPaymentModal.hide();
    },
    methods: {
        clickPlaceOrder: async function() {
            if (!this.isAllowClick) {
                return;
            }
            this.isAllowClick = false;
            this.modal.loadingModal.show();
            this.formValid = this.$refs['payment-form'].submitForm();
            if (this.formValid) {
                await this.checkCredit();
                this.trackPlaceOrder();
                this.PlaceOrderStore.state.placeOrder.updateDeliveryMethod(this.delivery.deliveryMethod)
                this.PlaceOrderStore.state.placeOrder.setFromPaymentModel(this.paymentModel)
                this.loadingStatus.placeOrder =  await this.apiPostPlaceOrder();
                this.modal.loadingModal.hide();
                if (this.checkLoadSuccess()) {
                    this.checkPayment();
                } else {
                    this.modal.errorModal.clearModal()
                            .setMsg(this.lbl.shoppingcart.error_credit)
                            .show();
                    this.modal.errorModal.onClose(()=> {
                        this.clickGotoHome();
                    })
                } 
            }
        },
        checkCredit: function() {
            return new Promise((resolve) => {
                if (this.PlaceOrderStore.state.placeOrder.channel == "omise") {
                    let selectCreditCard = this.$refs['payment-method'].getSelectCreditCard();
                    if (selectCreditCard) {
                        this.paymentModel.cardId = selectCreditCard.id;
                        if (this.isGuestAccountRegistered) { 
                            this.paymentModel.useSavedCard = false;
                        } else {
                            this.paymentModel.useSavedCard = true;
                        }
                    } else {
                        this.modal.errorModal.clearModal()
                                        .setMsg("Please select credit card")
                                        .show();
                        return;
                    }
                } else {
                    this.paymentModel.cardId = null;
                    this.paymentModel.useSavedCard = false;
                }
                resolve(true);
            });
        },
        checkPayment: async function() {
            if (this.omiseUrl) {
                this.gotoOmise();
            } else if (this.qrPaymentUrl) {
                this.qrCodeOmise()
            } else {
                this.gotoMyOrder();
            }
        },
        trackPlaceOrder: function() {
            let label = ''
            let labelTax = '';
            if (this.PlaceOrderStore.state.placeOrder.taxAddressKey) {
                let taxInvoice = this.$refs['tax-invoice'].getData();
                if (taxInvoice.taxName)
                    labelTax += taxInvoice.taxName + ' ';
                if (taxInvoice.taxId)
                    labelTax += taxInvoice.taxId + ' ';
                if (taxInvoice.taxDetail)
                    labelTax += taxInvoice.taxDetail + ' ';
                if (taxInvoice.taxSubDistrictName)
                    labelTax += taxInvoice.taxSubDistrictName + ' ';
                if (taxInvoice.taxDistrictName)
                    labelTax += taxInvoice.taxDistrictName + ' ';
                if (taxInvoice.taxProvinceName)
                    labelTax += taxInvoice.taxProvinceName + ' ';
                if (taxInvoice.zipcode)
                    labelTax += taxInvoice.zipcode + ' ';
            }
            
            if (this.PlaceOrderStore.state.placeOrder.channel == "omise") {
                label = "credit_card|";
            } else {
                label = "cash|";
            }
            if (labelTax != '') {
                label += labelTax.substring(0,labelTax.length - 1)
            }
            this.tracking.event('shopping_bag','click_place_order', label, null);
        },
        qrCodeOmise: function () {
            this.modal.qrPaymentModal.clearModal()
                            .setQrUrl(this.qrPaymentUrl)
                            .setBtnOk(this.lbl.shoppingcart.popup_qr_payment.save_qr)
                            .setBtnCancel(this.lbl.shoppingcart.popup_qr_payment.cancel)
                            .setExpireIn(this.qrExpireInSeconds)
                            .setTotal(this.PlaceOrderStore.state.placeOrder.total)
                            .show();
            this.modal.qrPaymentModal.onClickCancel(async ()=> {
                clearInterval(this.intervalQr);
                if (await this.apiPostPromptpayCancel()) {
                    this.modal.qrPaymentModal.hide();
                    this.$router.push('/fail');
                }
            })
            this.getStatusQrPayment();
            this.intervalQr = setInterval(() => {
                this.getStatusQrPayment();
            }, 5000);
        },
        
        getStatusQrPayment: async function() {
            if (await this.apiGetPromptpayStatus()) {
                this.modal.qrPaymentModal.hide();
                this.gotoMyOrder();
            }
        },


        gotoOmise: function() {
            this.CartCountStore.methods.updateCartCountFromCartItem([]);
            this.PlaceOrderStore.methods.removePlaceOrder();
            this.ShippingStore.methods.removeShipping();
            setTimeout(()=>{
                const link = document.getElementById('omiselink');
                link.href = this.omiseUrl;
                document.getElementById("omiselink").click();
            },1000);
        },
        gotoMyOrder: function() {
            this.CartCountStore.methods.updateCartCountFromCartItem([]);
            let cache = new CacheHelper(ConfigManager.getCacheType());
            let cacheReturnUrl = cache.getCache(this.KEY_COOKIE_RETURN_URL);
            if (cacheReturnUrl) {
                cache.removeCache(this.KEY_COOKIE_RETURN_URL);
                cacheReturnUrl += "myorder?tranId=" + this.ShippingStore.state.shipping.tranId;
                
                this.PlaceOrderStore.methods.removePlaceOrder();
                this.ShippingStore.methods.removeShipping();
             
                setTimeout(()=>{
                    const link = document.getElementById('applink');
                    link.href = cacheReturnUrl;
                    document.getElementById("applink").click();
                },1000);
            } else {
                this.PlaceOrderStore.methods.removePlaceOrder();
                this.ShippingStore.methods.removeShipping();
                this.$router.push("/myorder?from=shoppingcart&tranid=" + this.ShippingStore.state.shipping.tranId);
            }
        },
        clickGotoHome: function() {
            let cache = new CacheHelper(ConfigManager.getCacheType());
            let cacheReturnUrl = cache.getCache(this.KEY_COOKIE_RETURN_URL);
            
            this.PlaceOrderStore.methods.removePlaceOrder();
            this.ShippingStore.methods.removeShipping();
            if (cacheReturnUrl) {
                cache.removeCache(this.KEY_COOKIE_RETURN_URL);
                cacheReturnUrl += "home";
                window.location.href = cacheReturnUrl;
            } else {
                this.$router.push("/home");
            }
        },
        apiPostPlaceOrder: async function() {
            return new Promise((resolve) => {
                let params = this.PlaceOrderStore.state.placeOrder.getParams();
           
                BKCart.apiPostPlaceOrder(params).subscribe({
                    next: (data) => {
                        console.log(data)
                        if (data) {
                            if (data.RedirectUrl) {
                                this.omiseUrl = data.RedirectUrl;
                            }
                            if (data.QrCodeUrl) {
                                this.qrPaymentUrl = data.QrCodeUrl;
                                this.qrExpireInSeconds = data.ExpireInSeconds;
                            }

                            if (data.TranId) {
                                this.ShippingStore.state.shipping.tranId = data.TranId;
                                this.paymentModel.tranId = data.TranId;
                            }
                        }
                        resolve(true);
                    },
                    error: (err) => {
                        this.modal.loadingDeliveryModal.hide();
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },
        
        apiGetPromptpayStatus: function() {
            return new Promise((resolve) => {
                let params = {
                    tranId: this.paymentModel.tranId,   
                }
                BKCart.apiPromptpayStatus(params).subscribe({
                    next: (data) => {
                        console.log(data);
                        if (data.Paid) {
                            clearInterval(this.intervalQr);
                            resolve(true);
                        } else {
                            resolve(false);
                        }
                    },
                    error: (err) => {
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },
        apiPostPromptpayCancel: function() {
            return new Promise((resolve) => {
                let params = {
                    tranId: this.paymentModel.tranId,   
                }
                BKCart.apiPromptpayCancel(params).subscribe({
                    next: (data) => {
                        console.log(data);
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },
        clickBack: function() {
            this.$router.back();
        },
        checkLoadSuccess: function() {
            let found = true;
            for (let i in this.loadingStatus) {
                if (!this.loadingStatus[i]) {
                    found = false;
                    break;
                }
            }
            return found;
        },
        getPoint: function() {
            let sum = 0;
            sum = (this.PlaceOrderStore.state.placeOrder.subtotal - this.PlaceOrderStore.state.placeOrder.discount) / 25;
            return Util.stringFormat(this.lbl.shoppingcart.you_will_get_points,this.FilterNumberFormat(Math.floor(sum)))
        },
        getTotal: function() {
            return Util.stringFormat(this.lbl.shoppingcart.total_bath,this.FilterNumberFormat(this.PlaceOrderStore.state.placeOrder.total))
        },
    }
}
</script>

<style>

</style>